export const getInstallationDashboardUrl = <U extends { id: number; emsMasterDeviceId?: string }>(installation: U): string => {
  if (installation?.emsMasterDeviceId) {
    return `/dashboard/overview/${installation.id}/${installation.emsMasterDeviceId}`
  }
  return `/dashboard/overview/${installation.id}`
}

export const getInstallationDashboardUrlByIds = (activeInstallation?: number | string, activeStorage?: string | null): string => {
  return createDashboardIdsWithSuffix('/dashboard/overview', activeInstallation, activeStorage)
}

/**
 * Creates a dashboard URL with the given prefix and optional active installation and storage IDs.
 */
export const createDashboardIdsWithSuffix = (prefix: string, activeInstallation?: number | string, activeStorage?: string | null): string => {
  if (activeInstallation && !activeStorage) return `${prefix}/${activeInstallation}`
  if (activeInstallation && activeStorage) return `${prefix}/${activeInstallation}/${activeStorage}`
  return prefix
}
